var map = {
	"./de/mecha-btn.png": "HDhN",
	"./en/mecha-btn.png": "EJ/2",
	"./es/mecha-btn.png": "r/nk",
	"./fr/mecha-btn.png": "+uMR",
	"./ja/mecha-btn.png": "jSja",
	"./ko/mecha-btn.png": "I4h2",
	"./pt/mecha-btn.png": "ESgt",
	"./ru/mecha-btn.png": "qWfa",
	"./tc/mecha-btn.png": "+1uu",
	"./th/mecha-btn.png": "FLM6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "M05g";